import { render } from "./turmaCadastrar.vue?vue&type=template&id=110a13d8"
import script from "./turmaCadastrar.vue?vue&type=script&lang=js"
export * from "./turmaCadastrar.vue?vue&type=script&lang=js"

import "./turmaCadastrar.vue?vue&type=style&index=0&id=110a13d8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__